import type { HeaderLevel } from 'types/capi/content';

// they are styled one level lower because BrandedHeading is H2,
// so content headings start at H3
const CLASSES: Record<string, string> = {
  h1: 'text-title-lg',
  h2: 'text-title-md',
  h3: 'text-title-sm',
  h4: 'text-title-sm',
  h5: 'text-md font-semibold',
  h6: 'text-sm font-semibold'
};

type Props = {
  children: string;
  level: HeaderLevel;
};

export default function ContentHeading({ level, children }: Props) {
  const Element = level;
  const className = CLASSES[level];

  return <Element className={className}>{children}</Element>;
}
